import React, {createContext} from "react"

const LeftBarContext = createContext()

export default LeftBarContext